module.exports = __webpack_public_path__ + "img/icon-upload-file.dbd97358.svg";